type AudienceConfig = {
  oauth: { audience?: string }
  backendUrl: string
}

// An explicit audience lets several environments share one Auth0 API (Tilt
// namespaces do). Unset or empty, it falls back to the backend's own URL,
// which is what staging and production use.
export const resolveAuth0Audience = ({
  oauth,
  backendUrl,
}: AudienceConfig): string => oauth.audience || `${backendUrl}/api`
